<template>
  <div v-if="isAdd !== ''" class="books" @click="addBookrack">
    <img
      v-if="!isAdd"
      src="https://img01.yzcdn.cn/upload_files/2021/08/04/FswDTjy00O5Q0P8i5D0LKdGOuVI4.png"
    />
    <img
      v-if="isAdd"
      src="https://img01.yzcdn.cn/upload_files/2021/08/04/FmGErFGGoX7XYh66yoEAuFOhvkgA.png"
    />
  </div>
</template>

<style scoped>
.books {
  position: absolute;
  width: 78px !important;
  height: 26px !important;
  right: 17px !important;
  bottom: 15px !important;
  border-radius: 4px;
}

.books > img {
  max-width: 100%;
}
</style>

<script>
// background: #FF2638;
import { Toast } from 'vant'
import { addCollect, deleteCollect, getCollectBasicbookList } from '@/api/collectBook'
import { showRemoveBookRackModal } from '@/pages/answer/adModels'

export default {
  name: 'Shujia',
  props: ['bookInfo'],
  data() {
    return {
      isAdd: '',
      workbook_id: 0
    }
  },
  mounted() {
    const hash = u.path.hash.t(1)
    const id = u.qs(hash.t('?')[1])['id']
    this.workbook_id = id
    this.isJoinBook().then(() => {
      if (this.$route.query.isHasUnderRack === 'true' && this.isAdd) {
        showRemoveBookRackModal((close) => {
          this.addBookrack().then((res) => {
            setTimeout(() => {
              this.$router.back()
            }, 800)
            close()
          })
        })
      }
    })
  },
  methods: {
    // 查询该用户是否订阅该书
    isJoinBook() {
      return getCollectBasicbookList().then((res) => {
        const collectList = res.data.data
        this.isAdd = collectList.some((i) => String(i.book.id) === String(this.workbook_id))
      })
    },
    // 加入/移除书架
    async addBookrack() {
      if (this.isAdd) {
        await deleteCollect([
          { bookId: this.workbook_id, category: this.bookInfo.book.category }
        ]).then((res) => {
          if (res) {
            Toast({ duration: 1000, message: '已移出书架', forbidClick: true })
          }
        })
      } else {
        await addCollect([
          { bookId: this.workbook_id, category: this.bookInfo.book.category }
        ]).then((res) => {
          if (res) {
            Toast({ duration: 1000, message: '已加入书架', forbidClick: true })
          }
        })
      }
      this.isAdd = !this.isAdd
    }
  }
}
</script>
